import { Lightbulb } from 'lucide-react'

/**
 * Static panel rendering the bundled-retention alternative note.
 *
 * No data, no hooks — just a heads-up the operator can scan when
 * deciding whether to keep $5/5GB explicit or roll storage into the
 * per-minute rate. The full reasoning lives in the plan; this is the
 * abbreviated reminder so future-you doesn't have to dig it up.
 */
export function PricingStrategyNotePanel() {
  return (
    <section className="rounded-lg border border-primary/30 bg-primary/5 p-4">
      <header className="mb-2 flex items-center gap-2 font-medium">
        <Lightbulb className="h-4 w-4 text-primary" />
        Pricing strategy note
      </header>
      <div className="space-y-2 text-sm text-text-secondary">
        <p>
          $5 per 5 GB ≈ $1/GB-month is healthy SaaS markup over wholesale
          (~$0.025/GB on Railway/S3), but storage line items on top of
          per-minute fees can feel like nickel-and-diming.
        </p>
        <p>
          <strong className="text-text-primary">Alternative:</strong> include
          N days of recording retention in the $0.30/min price; charge for
          extended retention only (e.g. recordings older than 90 days). Same
          revenue, less friction at the customer-facing line item.
        </p>
        <p>
          The dollar formula lives in the Pricing Config above + a Stripe-side
          tier definition — flipping strategies is a config + Stripe-tier
          change, not a code change. Switch the &ldquo;Strategy&rdquo;
          dropdown to <code>bundled_retention</code> when ready.
        </p>
      </div>
    </section>
  )
}
